module.exports = __webpack_public_path__ + "img/privilegeleft.db4e4cb0.png";